var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOpenConsultHeartEmptyButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2493 2.5C16.7807 2.5 18.8327 4.58333 18.8327 7.5C18.8327 13.3333 12.5827 16.6667 10.4993 17.9167C8.41602 16.6667 2.16602 13.3333 2.16602 7.5C2.16602 4.58333 4.24935 2.5 6.74935 2.5C8.29932 2.5 9.66602 3.33333 10.4993 4.16667C11.3327 3.33333 12.6993 2.5 14.2493 2.5ZM11.2776 15.5032C12.0123 15.0404 12.6743 14.5796 13.2951 14.0858C15.7774 12.1108 17.166 9.95292 17.166 7.5C17.166 5.53397 15.8852 4.16667 14.2493 4.16667C13.3528 4.16667 12.3821 4.64092 11.6778 5.34517L10.4993 6.52369L9.32085 5.34517C8.61658 4.64092 7.64593 4.16667 6.74935 4.16667C5.1319 4.16667 3.83268 5.54708 3.83268 7.5C3.83268 9.95292 5.22124 12.1108 7.70363 14.0858C8.32435 14.5796 8.98643 15.0404 9.7211 15.5032C9.96985 15.6599 10.2169 15.8107 10.4993 15.9793C10.7818 15.8107 11.0288 15.6599 11.2776 15.5032Z",
    fill: "#FF8CBD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenConsultHeartEmptyButton);
export default __webpack_public_path__ + "static/media/open-consult-heart-empty-button.f4a65c1b8a06f62a137c9a184506ab38.svg";
export { ForwardRef as ReactComponent };